import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../../services/briefConfigService";
import { ToastService } from "@shared/lib/services";
import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";

interface IEditDataFieldV2DataRequest {
  campaignInfluencerId: string;
  dataField: { [key: string]: string | number };
}

export function useEditBriefCampaignDataFieldV2Data(briefId: string) {
  const {
    mutate: editDataField,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: (data: IEditDataFieldV2DataRequest) =>
      BriefConfigService.editCampaignDataFieldV2Data(
        data.campaignInfluencerId,
        data.dataField
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
    },
  });

  return {
    editDataField,
    isEditing,
    isEdited,
  };
}
